module.exports = __webpack_public_path__ + "static/anything-bdaa171c92e16ad6c2a66522cd4425e3.png";